import { render, staticRenderFns } from "./AlertsTabs.vue?vue&type=template&id=00239cdc&scoped=true&"
import script from "./AlertsTabs.vue?vue&type=script&lang=js&"
export * from "./AlertsTabs.vue?vue&type=script&lang=js&"
import style0 from "./AlertsTabs.vue?vue&type=style&index=0&id=00239cdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00239cdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VTab,VTabItem,VTabs})
